import styled, { css } from 'styled-components';
import { PropTypes } from 'prop-types';
import {
  primaryMixin,
  outlinePrimaryMixin,
  grayTextMixin,
  noBorderPrimaryMixin,
  smallMixin,
  secundaryMixin,
  thirdMixin,
  forthMixin,
  fifthhMixin
} from './styles';
import { QuicksandBold } from '../Text';
import Colors from 'constants/Colors';
import {Breakpoints} from "../../constants/Breakpoints";

const propTypes = {
  outlinePrimary: PropTypes.bool,
  type: PropTypes.string
};

const defaultProps = {
  outlinePrimary: false,
  type: 'button'
};

const Button = styled.button`
  padding: 0.10rem 0.20rem;
  width: 100%;
  text-transform: uppercase;
  letter-spacing: -0.5px;
  font-size: 16px;
  height: 42px;
  white-space: nowrap;
  margin: 0px 0px 0px 0px;
  color:${Colors.GRAY[6]}

  ${QuicksandBold}

  border: 0 none;
  border-radius: 8px;
  background: transparent;

  cursor: pointer;
  transition: background-color 0.15s ease, color 0.15s ease, width 0.3s ease, border 0.5s ease, border-color 0.5s ease, box-shadow 0.15s ease;

  text-align: center;
  &:focus,
  &:active { outline: none; }

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }

  ${({ outlinePrimary }) => outlinePrimary && outlinePrimaryMixin}
  ${({ text }) => text && grayTextMixin}
  ${({ primary }) => primary && primaryMixin}
  ${( {secundary }) => secundary && secundaryMixin}
  ${({ third }) => third && thirdMixin}
  ${({ noBorderPrimary }) => noBorderPrimary && noBorderPrimaryMixin}
  ${({ forth }) => forth && forthMixin}
  ${({ fifth }) => fifth && fifthhMixin}
  ${({ sm }) => sm && smallMixin}

  ${({ fullWidth }) =>
    fullWidth &&
    css`
      width: 100%;
    `}

    @media(min-width: ${Breakpoints.sm}) {  
    padding: 0.75rem 1.20rem;
    padding: 0.75rem 3.75rem;
    width: auto;
  }
  `;


export const ButtonMiradorOrange = styled(Button)`
border-radius: 2em;
background: rgb(251,160,52);
background: linear-gradient(180deg, rgba(251,160,52,1) 50%, rgba(199,115,4,1) 89%);
padding: 0.10rem 2rem !important;
-webkit-box-shadow: 0px 15px 15px -3px rgba(248,169,52,0.4); 
box-shadow: 0px 15px 15px -3px rgba(248,169,52,0.4);
`
export const ButtonMiradorWhite = styled(Button)`
text-transform: none;
height: 4em;
font-size: 10px;
border-radius: 2em;
border: 1px solid #D1D1D1;
background: rgb(255,255,255);
padding: 0.10rem 2rem !important;
-webkit-box-shadow: 0px 3px 10px -3px rgba(0,0,0,0.2); 
box-shadow: 0px 3px 10px -3px rgb(0, 0, 0, 0.2);
`

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction:row;
  justify-content: space-between;
  align-items:center;
  margin-top: 20px;
  width: 100%;
  padding: 0px 0px 0px 0px;
`;

export const ButtonContent = styled.div`
    display:flex;
    flex-direction:auto;
    background-color:#FFF;  
`;

Button.propTypes = propTypes;
Button.defaultProps = defaultProps;

export default Button;
